/**
 *	Function that checks if a string matches Salesforce Id pattern
 *
 *	@param id - as a string
 *
 * @example
 * isSalesforceId(product.salesforceProductId)
 *
 * @returns true or false
 */

export default function isSalesforceId(id: string) {
	const salesforceIdRegex = new RegExp(/[a-zA-Z0-9]{18}|[a-zA-Z0-9]{15}/)
	if (salesforceIdRegex.test(id)) return true
	else return false
}
